import A from "./A.svg";
import B from "./B.svg";
import C from "./C.svg";
import J from "./J.svg";
import M from "./M.svg";
import N from "./N.svg";
import R from "./R.svg";
import S from "./S.svg";
import T from "./T.svg";

const avatars: { [key: string]: string } = {
  A,
  B,
  C,
  J,
  M,
  N,
  R,
  S,
  T
};

export const getAvatar = (name: string) => {
  if (name.length === 0) {
    return A;
  }
  const character = name[0].toUpperCase();
  if (avatars[character]) {
    return avatars[character];
  }

  return A;
};
